import { createContext, useContext } from 'react';
import { SearchSuppliersPageProps } from '@bridebook/web/app-shared/lib/search-suppliers/types';

const SearchSuppliersContext = createContext<SearchSuppliersPageProps | undefined>(undefined);

export const SearchSuppliersContextProvider = SearchSuppliersContext.Provider;

export const useSearchSuppliersContext = (): SearchSuppliersPageProps => {
  const context = useContext(SearchSuppliersContext);
  if (context === undefined) {
    throw new Error(
      'SearchSuppliersContextConsumer must be used within a SearchSuppliersContextProvider',
    );
  }

  return context;
};
